import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/providers/StoreProvider';
import {InventoryItemsName} from "@/entities/inventory/types";
import EffectOviFlex from '@/shared/pictures/effect_ovieflex.png';
import EffectEmptyNet from '@/shared/pictures/effect_emptynet.png';
import ImgStreak from '@/shared/pictures/streak_empty.png';

export const Effects = observer(() => {
    const { gameStore, effectsStore, inventoryStore } = useStore();

    if(!effectsStore.activeEffects) {return null}
    return (
      <div className='effects'>
          <div className="effects_items">
              {effectsStore.activeEffects.has(InventoryItemsName.OviFlex100)&&
                  <div className="effects_image-wrapper"
                       data-count={inventoryStore.activeConsumables[InventoryItemsName.OviFlex100]} >
                      <img
                          style={{width:50*gameStore.scale, height:50*gameStore.scale}}
                          className={`effects_image ${inventoryStore.activeConsumables[InventoryItemsName.OviFlex100] <= 3?'ending':''}`}
                          width={50*gameStore.scale}
                          src={EffectOviFlex}
                          alt=''
                      />
                  </div>}
              {effectsStore.activeEffects.has(InventoryItemsName.EmptyNet10)&&
                  <div className="effects_image-wrapper"
                       data-count={inventoryStore.activeConsumables[InventoryItemsName.EmptyNet10]} >
                      <img
                          style={{width:50*gameStore.scale, height:50*gameStore.scale}}
                          className={`effects_image ${inventoryStore.activeConsumables[InventoryItemsName.EmptyNet10] <= 3?'ending':''}`}
                          width={50*gameStore.scale}
                          src={EffectEmptyNet}
                          alt=''
                      />
                  </div>}
              {effectsStore.activeEffects.has(InventoryItemsName.EmptyNet25)&&
                  <div className="effects_image-wrapper"
                       data-count={inventoryStore.activeConsumables[InventoryItemsName.EmptyNet25]} >
                      <img
                          style={{width:50*gameStore.scale, height:50*gameStore.scale}}
                          className={`effects_image ${inventoryStore.activeConsumables[InventoryItemsName.EmptyNet25] <= 3?'ending':''}`}
                          width={50*gameStore.scale}
                          src={EffectEmptyNet}
                          alt=''
                      />
                  </div>}
          </div>
          {gameStore.hitStreak > 0&&
              <div className="streak_item" style={{width:50*gameStore.scale, height:50*gameStore.scale}}>
                  <img className={`streak_image`} src={ImgStreak} alt='' />
                  {gameStore.hitStreak}
              </div>
          }

      </div>
    );

});
